import { Dropdown } from 'components/dropdown/Dropdown.tsx';
import { cn } from 'utils/cn.tsx';
import { Icon, type IconType } from 'components/atoms/Icon.tsx';
import cx from 'clsx';

export type IconOptionType<TOptionId> = { id: TOptionId; icon?: IconType };

export function IconOption<TOptionId = string, TOption = IconOptionType<TOptionId>>({
	label,
	icon,
	props,
	isFocused,
	aria,
	id,
	dataTest,
	className,
	iconSize = 24,
}: Pick<Dropdown.RenderOptionProps<TOption>, 'props' | 'isFocused' | 'aria' | 'id' | 'className' | 'iconSize'> & {
	label: string;
	icon?: IconType;
	dataTest: TOptionId;
}) {
	return (
		<button
			className={cn(
				'group flex items-center gap-[10px] w-full text-left py-1 mb-2 text-dark-blue cursor-pointer',
				className,
			)}
			{...props}
			{...aria}
			data-test={dataTest}
			id={id}
		>
			{icon && (
				<Icon
					type={icon}
					className={cx(
						'text-dark-blue-25 group-hover:text-dark-blue group-focus:text-dark-blue transition-colors',
						isFocused ? 'text-dark-blue' : null,
					)}
					fill
					size={iconSize}
				/>
			)}{' '}
			{label}
		</button>
	);
}
